module.exports = __webpack_public_path__ + "assets/img/官网首页_03.f9c9df8e.jpg";